import { render, staticRenderFns } from "./transitionSummary.vue?vue&type=template&id=b08aeab2&scoped=true&"
import script from "./transitionSummary.vue?vue&type=script&lang=js&"
export * from "./transitionSummary.vue?vue&type=script&lang=js&"
import style0 from "./transitionSummary.vue?vue&type=style&index=0&id=b08aeab2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08aeab2",
  null
  
)

export default component.exports